/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadComment } from './LeadComment';
import {
    LeadCommentFromJSON,
    LeadCommentFromJSONTyped,
    LeadCommentToJSON,
    LeadCommentToJSONTyped,
} from './LeadComment';

/**
 * 
 * @export
 * @interface FindAllCommentsForLead200Response
 */
export interface FindAllCommentsForLead200Response {
    /**
     * 
     */
    data?: Array<LeadComment>;
}

/**
 * Check if a given object implements the FindAllCommentsForLead200Response interface.
 */
export function instanceOfFindAllCommentsForLead200Response(value: object): value is FindAllCommentsForLead200Response {
    return true;
}

export function FindAllCommentsForLead200ResponseFromJSON(json: any): FindAllCommentsForLead200Response {
    return FindAllCommentsForLead200ResponseFromJSONTyped(json, false);
}

export function FindAllCommentsForLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCommentsForLead200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadCommentFromJSON)),
    };
}

export function FindAllCommentsForLead200ResponseToJSON(json: any): FindAllCommentsForLead200Response {
    return FindAllCommentsForLead200ResponseToJSONTyped(json, false);
}

export function FindAllCommentsForLead200ResponseToJSONTyped(value?: FindAllCommentsForLead200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadCommentToJSON)),
    };
}

